import React from "react";
import classNames from "classnames";
import {DaEvadereIcon, InAttesaIcon, InValutazioneIcon, Triangle} from "./wf.dashboard.comps";
import styles from "../wf.dashboard.module.css";

export const Legenda: React.FC = () => {
    return <div className="grid grid-cols-2 gap-3">
        <div className="pt-3">Presente tempo pieno</div>
        <div className="pl-3 pt-3">
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT)}>&nbsp;</div>
        </div>
        <div>Presente part-time</div>
        <div className="pl-3">
            <div className={classNames(styles.cella, styles.cella_w, styles.presentePT)}>&nbsp;</div>
        </div>
        <div>Assente</div>
        <div className="pl-3">
            <div className={classNames(styles.cella, styles.cella_w, styles.assenteBgColor)}>&nbsp;</div>
        </div>
        <div>In parte assente</div>
        <div className="pl-3 inline-flex gap-3">
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor)}><Triangle/></div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presentePT, styles.assenteColor)}><Triangle/></div>
        </div>
        <div className="pb-3">Richiesta da evadere</div>
        <div className="pb-3 pl-3 inline-flex gap-3">
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <InAttesaIcon/></div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <Triangle/>
                <InAttesaIcon/>
            </div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <InValutazioneIcon/></div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <Triangle/>
                <InValutazioneIcon/>
            </div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <DaEvadereIcon/></div>
            <div className={classNames(styles.cella, styles.cella_w, styles.presenteFT, styles.assenteColor, 'relative')}>
                <Triangle/>
                <DaEvadereIcon/>
            </div>
        </div>
    </div>
}